// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1WQ0j","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__274Jh"};